import {
  SET_LIST_COURSE_SESSION_TOPIC_DATA,
  SET_LIST_COURSE_SESSION_TOPIC_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listCourseSessionTopicData: null,
  listCourseSessionTopicDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_COURSE_SESSION_TOPIC_DATA:
      return {
        ...state,
        loading: false,
        listCourseSessionTopicData: action.listCourseSessionTopicData,
      };

    case SET_LIST_COURSE_SESSION_TOPIC_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listCourseSessionTopicDataTotal: action.listCourseSessionTopicDataTotal,
      };

    default:
      return { ...state };
  }
};
